import type { BoxInfo, CardInfo } from '@lub0v/santa-utils';

/** Show the furthest confirmed step; never infer delivery from a revealed giftee. */
export function participantCardStatus(card: CardInfo, info: BoxInfo) {
  if (card.isGiftReceived) return 'giftReceived';
  if (card.isGiftOnItsWay) return 'giftOnWay';
  if (info.isActiveDraw && card.isWardKnown) return 'gifteeKnown';
  if (!card.isVerified) {
    return !info.isActiveDraw && info.box.isInviteAfterDraw ? 'waitingDraw' : 'waitingConfirmation';
  }
  if (!info.isActiveDraw) return 'cardOpened';
  if (info.isAdmin && !card.wardId) return 'noGiftee';
  return 'waitingGiftee';
}
